<template>
    <section class="projectCont">

        <div class="projectLogo_cont">
            <h2 class="projName">{{ projectData.title }}</h2>
            <img :src="projectData.icon[0]" alt="project logo" class="projectLogo" />
        </div>

        <p class="projDesc" v-html="projectData.desc"></p>

        <div class="projDet">
            <div
                class="projTech collab"
                v-if="projectData.colaborator.length > 0 && projectData.colaborator[0] != ''"
            >
                <h3>Collaborators:</h3>

                <a v-for="(colaborator, z) in projectData.colaborator" :key="z" :href="colaborator[2]" target="_blank">
                    <div>
                        <img :src="colaborator[1]" alt="collaborator">
                        <p>{{colaborator[0]}}</p>
                    </div>
                </a>
            </div>

            <div class="projFooter" v-if="projectData.open">
                <h3>Project repository</h3>
                <a target="_blank" :href="projectData.source">{{projectData.source}}</a>
            </div>

        </div>
    </section>
</template>

<script>

export default {
    props: {
        projectData: Object,
    }
}

</script>

<style scoped lang="scss">

    .collab {
        h3 {
            margin-bottom: 10px;
        }
        div {
            border: 1px solid rgba(0, 0, 0, 0.25);
            background-color: rgba(255, 255, 255, 0.4);
            display: inline-block;
            display: flex;
            max-width: 207px;
            align-items: center;
            overflow: hidden;
            padding: 3px;

            img {
                height: 50px;
                width: 50px;
                object-fit: cover;
                border-radius: 50%;
            }
            p {
                font-weight: bold;
                font-size: 17px;
                margin: 0 10px;

                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 2; 
                -webkit-box-orient: vertical;
                text-align: initial;

                cursor: pointer;
            }
        }
        a {
            background-color: unset;
            color: #000;
            padding: 0;
            margin: 0;
            text-decoration: none;
            display: inline-block;
            margin: 7px;
        }
    }
    .projectCont {
        width: 670px;
        height: auto;
        padding: 0px 0 10px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #99999944;
        border-radius: 5px;
        box-shadow: 0px 0px 5px #000000ab;
        -webkit-backdrop-filter: blur(6.2px);
        backdrop-filter: blur(6.2px);
        margin: 5px 20px;
        height: auto;
        overflow: hidden;
    }

    .projectLogo_cont {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
        max-height: 200px;
        width: 100%;
        overflow: hidden;
        margin-bottom: 15px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px; 
        .projectLogo {
            height: 100%;
            width: 100%;
            max-height: 300px;
            min-height: 300px;
            object-fit: cover;
            object-position: center center;
            transform: scale(1.5);
            isolation: isolate;
            background: #fff;
            opacity: .3;
            transition: .9s;
        }
        &:hover .projectLogo {
            transform: scale(1);
            opacity: .7;
        }
        &:hover .projName {
            font-size: 65px;
            opacity: .2;
            transition: .7s;
        }
        .projName {
            white-space: nowrap;
            font-size: 50px;
            position: absolute;
            z-index: 1;
            transition: .5s;
            text-shadow: 0 0 10px #fff;
        }
    } 


    .projDesc {
        text-align: justify;
        margin: 0 60px 0 60px;
    }

    .projTech {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 5px;
        min-width: 235px;
        width: 100%;
        text-align: center;
    }

    .projTech_cont {
        display: inline-flex;
        max-width: 130px;
        margin: 10px 15px;
    }

    .projDet {
        width: 75%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
    }

    .skillIcon {
        mix-blend-mode: exclusion;
        will-change: opacity;
        height: 60px;
        width: 60px;
        margin: 0 10px;
        border-radius: 50%;
        filter: invert(1);
        object-fit: cover;
        transition: opacity 0.7s;
    }

    .projFooter {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 15px;
        width: 100%;
        min-width: 235px;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
        a {
            text-decoration: none;
            color: #fff;
            background: #000;
            padding: 1px 7px;
            font-weight: bold;
        }
        h3 {
            margin-bottom: 8px;
        }
    }

    a {
        text-decoration: none;
        color: #fff;
        background: #000;
        padding: 1px 7px;
        font-weight: bold;
    }

    @media screen and (max-width: 500px) {

        .skillIcon {
            mix-blend-mode: exclusion;
            will-change: opacity;
            height: 50px;
            width: 50px;
            margin: 0 5px;
            border-radius: 50%;
            object-fit: cover;
            transition: opacity 0.7s;
        }
    }
    
</style>